export default {
  props: {
    value: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  mounted () {
    this.dialog = true
  },
  methods: {
    redirectToListOfAllBaskets () {
      this.$router.push({ name: 'ListBaskets' })
    },
    closeModal () {
      this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    }
  }
}
